<template>
  <tr class="w-full">
    <td class="px-5 py-5 border-b border-gray-200 bg-white text-md">
      <div class="flex flex-col ">
        <div class="text-gray-800 font-bold">
            {{ masterclass.teacher.name }}
        </div>
      </div>
    </td>
    <td class="px-5 py-5 border-b border-gray-200 bg-white text-md">
      <div class="flex flex-col ">
        <div class="text-gray-700 text-sm">
            {{ masterclass.title }}
        </div>
      </div>
    </td>
    <td class="px-5 py-5 border-b border-gray-200 bg-white text-md">
        <div class="flex flex-col ">
            <masterclass-date :masterclass="masterclass" class="text-sm" />
        </div>
    </td>
    <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
      <div class="flex items-center justify-center">
        <ios-switch v-model="isNext" @changed="setMasterclassAsNext" />
      </div>
    </td>
    <td class="w-1/3 px-5 py-5 border-b border-gray-200 bg-white text-sm">
      <div class="flex justify-between items-center px-5">
        <button class="bg-gray-600 p-2 rounded-lg text-gray-300
          hover:bg-gray-300 hover:text-gray-700">
            Open
        </button>
      </div>
    </td>
  </tr>
</template>

<script>
import axios from 'axios';
import iosSwitch from '../iosSwitch.vue';
import MasterclassDate from '../masterclasses/MasterclassDate.vue';

export default {
  components: { iosSwitch, MasterclassDate },
  props: ['masterclass'],

  data() {
    return {
      isNext: this.masterclass.is_next !== 0,
    };
  },

  methods: {
    setMasterclassAsNext() {
      axios.put(`/api/masterclasses/${this.masterclass.id}`, { is_next: !this.isNext }).then(() => {
        this.createNotification('success', 'Masterclass aggiornata con successo');
      }).catch((error) => {
        console.log(error);
      });
    },

  },
};

</script>

<style scoped>

</style>
